import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AppService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { SessionTopicAssignmentByEvent } from '../session-assignments.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(service: VolunteeringAreaService, util: UtilityService, dialogService: DialogService, app: AppService): GridSetup<SessionTopicAssignmentByEvent> {

	return {
		rowName: { singular: 'Topic Assignment', plural: 'Topic Assignments' },
		getRowKey: row => '' + row.eventId + '_' + row.topicId,
		stateKey: 'topic-assignment-grid',
		actions: getActions(service, dialogService),
		buttons: [],
		columns: getColumns(util, app),
	}
}
